/**
 * CPH Wheels — Wheel Configurator Modal
 * Normal fælg: Tilbehør → Sæson → Redirect til dæk
 * Custom fælg: Custom mål → Tilbehør → Sæson → Redirect til dæk
 */
(function () {
  'use strict';

  var ETRTO = {
    '5.5': [155,185], '6.0': [175,195], '6.5': [185,205],
    '7.0': [195,215], '7.5': [205,225], '8.0': [215,235],
    '8.5': [225,245], '9.0': [235,255], '9.5': [245,265],
    '10.0': [255,275], '10.5': [265,285], '11.0': [275,295]
  };

  var SEASON_COLLECTIONS = {
    'Sommerdæk': 'sommerdaek',
    'Vinterdæk': 'vinterdaek',
    'Helårsdæk': 'helarsdaek'
  };

  var state = {
    currentStep: 0,
    steps: [],           // dynamisk: ['custom','accessories','season'] eller ['accessories','season']
    rimVariantId: null,
    isCustom: false,
    customBP: null,      // valgt custom krydsmål
    customET: null,      // valgt custom ET
    termsAccepted: false,
    selectedAccessories: {},
    selectedSeason: null
  };

  var config;
  var els = {};

  /* ─── Helpers ─── */
  function fmt(cents) {
    var kr = typeof cents === 'number' ? cents / 100 : 0;
    return kr.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr.';
  }

  function parseRimWidth(raw) {
    if (!raw) return null;
    var m = String(raw).match(/([\d]+\.?[\d]*)/);
    return m ? m[1] : null;
  }

  function parseRimDiameter(raw) {
    if (!raw) return null;
    return String(raw).replace(/"/g, '').trim();
  }

  function escapeHTML(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function showError(msg) {
    els.error.textContent = msg;
    els.error.style.display = 'block';
  }

  function hideError() {
    if (els.error) els.error.style.display = 'none';
  }

  /* ─── Cart API ─── */
  function addToCart(items, properties) {
    var payload = { items: items.map(function(item) {
      var id = item.id;
      // Hvis id er GID (gid://shopify/ProductVariant/12345), udtræk numerisk del
      if (typeof id === 'string' && id.indexOf('gid://') === 0) {
        id = id.split('/').pop();
      }
      var obj = { id: parseInt(id, 10), quantity: item.quantity };
      if (item.properties) obj.properties = item.properties;
      return obj;
    })};
    console.log('[WC] addToCart payload:', JSON.stringify(payload));
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) {
        return r.text().then(function(text) {
          console.error('[WC] Cart error ' + r.status + ':', text);
          throw new Error('Cart error: ' + r.status + ' — ' + text);
        });
      }
      return r.json();
    });
  }

  /* ─── Render: Custom mål step ─── */
  function renderCustomStep() {
    var panel = els.customPanel;
    if (!panel) return;

    // Parse custom krydsmål liste
    var bpList = (config.krydsmalCustom || '').split(/,\s*(?=\d)/).map(function(s) { return s.trim(); }).filter(Boolean);
    // Parse custom ET range: "0 - 20" → min=0, max=20
    var etParts = (config.etCustom || '').split(/\s*-\s*/);
    var etMin = parseInt(etParts[0], 10) || 0;
    var etMax = parseInt(etParts[1], 10) || 60;

    var html = '';

    // Handelsbetingelser checkbox
    html += '<div class="wc-custom-field">';
    html += '<label class="wc-checkbox-label">';
    html += '<input type="checkbox" id="wc-terms-check"> ';
    html += '<span>Har du læst handelsbetingelser vedrørende custom fælge?<span style="color:#b91c1c;">*</span></span>';
    html += '</label>';
    html += '</div>';

    // Krydsmål dropdown
    html += '<div class="wc-custom-field">';
    html += '<label class="wc-field-label">Custom krydsmål<span style="color:#b91c1c;">*</span></label>';
    html += '<select id="wc-custom-bp" class="wc-custom-select">';
    html += '<option value="">Vælg krydsmål</option>';
    bpList.forEach(function(bp) {
      html += '<option value="' + escapeHTML(bp) + '">' + escapeHTML(bp) + '</option>';
    });
    html += '</select>';
    html += '</div>';

    // ET input
    html += '<div class="wc-custom-field">';
    html += '<label class="wc-field-label">Custom ET<span style="color:#b91c1c;">*</span></label>';
    html += '<div class="wc-et-range">';
    html += '<input type="number" id="wc-custom-et" class="wc-custom-input" min="' + etMin + '" max="' + etMax + '" placeholder="' + etMin + ' - ' + etMax + '">';
    html += '<span class="wc-et-hint">Muligt range: ' + etMin + ' - ' + etMax + '</span>';
    html += '</div>';
    html += '</div>';

    panel.innerHTML = '<p class="wc-panel-title">Angiv custom mål</p>' + html;

    // Bind events
    var termsCheck = document.getElementById('wc-terms-check');
    var bpSelect = document.getElementById('wc-custom-bp');
    var etInput = document.getElementById('wc-custom-et');

    function onCustomChange() {
      state.termsAccepted = termsCheck.checked;
      state.customBP = bpSelect.value || null;
      var etVal = parseInt(etInput.value, 10);
      state.customET = (!isNaN(etVal) && etVal >= etMin && etVal <= etMax) ? etVal : null;
      updateButtons();
    }

    termsCheck.addEventListener('change', onCustomChange);
    bpSelect.addEventListener('change', onCustomChange);
    etInput.addEventListener('input', onCustomChange);
  }

  /* ─── Render: Accessories step ─── */
  function renderAccessories() {
    var container = els.accessoriesList;
    if (!container) return;
    container.innerHTML = '';
    var accs = config.accessories.filter(function (a) { return a && a.variantId; });

    if (accs.length === 0) {
      container.innerHTML = '<p style="color:#888;font-size:14px;">Ingen tilbehør tilgængelige.</p>';
      return;
    }

    accs.forEach(function (acc) {
      var selected = !!state.selectedAccessories[acc.variantId];
      var card = document.createElement('div');
      card.className = 'wc-acc-card' + (selected ? ' selected' : '');
      card.innerHTML =
        '<img src="' + escapeHTML(acc.image || '') + '" alt="' + escapeHTML(acc.title) + '" loading="lazy">' +
        '<div class="wc-acc-info">' +
          '<h4>' + escapeHTML(acc.title) + '</h4>' +
          '<div class="wc-price">' + fmt(acc.price) + '</div>' +
        '</div>' +
        '<button class="wc-acc-toggle" type="button">' + (selected ? 'Fjern' : 'Tilføj') + '</button>';

      card.querySelector('.wc-acc-toggle').addEventListener('click', function () {
        if (state.selectedAccessories[acc.variantId]) {
          delete state.selectedAccessories[acc.variantId];
        } else {
          state.selectedAccessories[acc.variantId] = true;
        }
        renderAccessories();
      });

      container.appendChild(card);
    });
  }

  /* ─── Render: Season step ─── */
  function renderSeasons() {
    var btns = els.seasons.querySelectorAll('.wc-season-btn');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.getAttribute('data-season') === state.selectedSeason) {
        btn.classList.add('selected');
      } else {
        btn.classList.remove('selected');
      }
    }
  }

  /* ─── Step Navigation ─── */
  var STEP_LABELS = {
    'custom': 'Angiv custom mål',
    'accessories': 'Tilbehør',
    'season': 'Vælg dæktype'
  };

  function goToStep(idx) {
    state.currentStep = idx;
    hideError();

    var stepName = state.steps[idx];

    // Show/hide panels
    var panels = document.querySelectorAll('.wc-panel');
    for (var i = 0; i < panels.length; i++) {
      panels[i].classList.remove('active');
    }
    var activePanel = document.querySelector('[data-panel="' + stepName + '"]');
    if (activePanel) activePanel.classList.add('active');

    // Update step dots
    var dots = document.querySelectorAll('.wc-step-dot');
    for (var j = 0; j < dots.length; j++) {
      dots[j].className = 'wc-step-dot';
      if (j === idx) dots[j].classList.add('active');
      else if (j < idx) dots[j].classList.add('done');
    }

    var bars = document.querySelectorAll('.wc-step-bar');
    for (var k = 0; k < bars.length; k++) {
      bars[k].classList.toggle('done', k < idx);
    }

    // Title
    els.modalTitle.textContent = STEP_LABELS[stepName] || '';

    // Render content
    if (stepName === 'custom') renderCustomStep();
    if (stepName === 'accessories') renderAccessories();
    if (stepName === 'season') renderSeasons();

    updateButtons();
  }

  function updateButtons() {
    var idx = state.currentStep;
    var stepName = state.steps[idx];
    var isLast = idx === state.steps.length - 1;

    els.backBtn.style.display = idx > 0 ? '' : 'none';

    if (isLast) {
      // Last step = season
      els.nextBtn.textContent = state.selectedSeason ? 'Tilføj og se dæk' : 'Vælg dæktype';
      els.nextBtn.disabled = !state.selectedSeason;
    } else if (stepName === 'custom') {
      els.nextBtn.textContent = 'Næste';
      els.nextBtn.disabled = !(state.termsAccepted && state.customBP && state.customET !== null);
    } else {
      els.nextBtn.textContent = 'Næste';
      els.nextBtn.disabled = false;
    }
  }

  function buildStepDots() {
    var container = document.getElementById('wc-steps-container');
    if (!container) return;
    var html = '';
    state.steps.forEach(function(step, i) {
      if (i > 0) html += '<div class="wc-step-bar"></div>';
      html += '<div class="wc-step-dot" data-step="' + i + '">' + (i + 1) + '</div>';
    });
    container.innerHTML = html;
  }

  /* ─── Build tire page URL: redirecter til sæson-kollektion med filtre ─── */
  var SEASON_COLLECTION = {
    'Sommerdæk': 'sommerdaek',
    'Vinterdæk': 'vinterdaek',
    'Helårsdæk': 'helarsdaek',
  };

  function buildTireUrl() {
    // Vælg kollektion baseret på sæson
    var collection = SEASON_COLLECTION[state.selectedSeason] || 'daek';
    var diameter = parseRimDiameter(config.rimDiameter);
    var etrto = (function() {
      var w = parseRimWidth(config.rimWidth);
      return w ? (ETRTO[w] || null) : null;
    })();

    var params = [];

    // Filter: diameter (tommer) — kun dæk der passer fælgen
    if (diameter) {
      params.push('filter.p.m.custom.daektommer=' + encodeURIComponent(diameter));
    }

    // Filter: ETRTO-bredde-range (én filter per standard dækbredde i step 5)
    if (etrto) {
      for (var w = etrto[0]; w <= etrto[1]; w += 5) {
        params.push('filter.p.m.custom.daekbredde=' + encodeURIComponent(String(w)));
      }
    }

    return '/collections/' + collection + (params.length ? '?' + params.join('&') : '');
  }

  /* ─── Add to cart and redirect ─── */
  function addAndGoToTires() {
    var items = [];

    // 4× fælg med custom properties hvis relevant
    if (state.rimVariantId) {
      var rimItem = { id: state.rimVariantId, quantity: 4 };
      if (state.isCustom && state.customBP && state.customET !== null) {
        rimItem.properties = {
          'Custom krydsmål': state.customBP,
          'Custom ET': String(state.customET)
        };
      }
      items.push(rimItem);
    }

    // Tilbehør
    config.accessories.forEach(function (a) {
      if (a && state.selectedAccessories[a.variantId]) {
        items.push({ id: a.variantId, quantity: 1 });
      }
    });

    if (items.length === 0) {
      window.location.href = buildTireUrl();
      return;
    }

    els.nextBtn.disabled = true;
    els.nextBtn.textContent = 'Tilføjer...';

    addToCart(items)
      .then(function () {
        window.location.href = buildTireUrl();
      })
      .catch(function (err) {
        // Prøv at parse Shopify fejl
        var msg = err.message || 'Ukendt fejl';
        try {
          var match = msg.match(/\{.*\}/);
          if (match) {
            var j = JSON.parse(match[0]);
            if (j.description) msg = j.description;
            else if (j.message) msg = j.message;
          }
        } catch (e) { /* ignore */ }
        showError('Kunne ikke tilføje til kurv: ' + msg);
        els.nextBtn.disabled = false;
        els.nextBtn.textContent = 'Tilføj og se dæk';
        console.error('WC cart error:', err);
      });
  }

  function addRimOnlyAndGoToCart() {
    if (!state.rimVariantId) {
      window.location.href = '/cart';
      return;
    }

    var rimItem = { id: state.rimVariantId, quantity: 4 };
    if (state.isCustom && state.customBP && state.customET !== null) {
      rimItem.properties = {
        'Custom krydsmål': state.customBP,
        'Custom ET': String(state.customET)
      };
    }

    els.skipBtn.disabled = true;
    els.skipBtn.textContent = 'Tilføjer...';

    addToCart([rimItem])
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        showError('Kunne ikke tilføje til kurv. Prøv igen.');
        els.skipBtn.disabled = false;
        els.skipBtn.textContent = 'Nej tak, gå til kurv';
        console.error('WC cart error:', err);
      });
  }

  /* ─── Modal open / close ─── */
  function openModal(rimVariantId) {
    state.rimVariantId = rimVariantId;
    state.isCustom = config.isCustom;
    state.termsAccepted = false;
    state.customBP = null;
    state.customET = null;
    state.selectedAccessories = {};
    state.selectedSeason = null;

    // Byg steps dynamisk
    state.steps = [];
    if (state.isCustom) state.steps.push('custom');
    state.steps.push('accessories');
    state.steps.push('season');

    state.currentStep = 0;

    buildStepDots();

    els.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    goToStep(0);
  }

  function closeModal() {
    els.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ─── Intercept add-to-cart ─── */
  function interceptAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;

      var action = form.getAttribute('action');
      if (!action) return;

      try {
        var url = new URL(action, window.location.origin);
        if (url.pathname !== '/cart/add') return;
      } catch (_) {
        if (action !== '/cart/add') return;
      }

      if (!document.getElementById('wc-overlay')) return;

      e.preventDefault();
      e.stopPropagation();

      var variantInput = form.querySelector('[name="id"]');
      var variantId = variantInput ? variantInput.value : null;

      if (!variantId) {
        console.error('WC: Could not find variant ID in form.');
        return;
      }

      openModal(variantId);
    }, true);
  }

  /* ─── Init ─── */
  function init() {
    config = window.__wcConfig;
    if (!config) return;

    config.accessories = (config.accessories || []).filter(function (a) {
      return a && a.title && a.variantId;
    });

    els.overlay = document.getElementById('wc-overlay');
    els.modalTitle = document.getElementById('wc-modal-title');
    els.error = document.getElementById('wc-error');
    els.customPanel = document.querySelector('[data-panel="custom"]');
    els.accessoriesList = document.getElementById('wc-accessories-list');
    els.seasons = document.getElementById('wc-seasons');
    els.nextBtn = document.getElementById('wc-next-btn');
    els.backBtn = document.getElementById('wc-back-btn');
    els.skipBtn = document.getElementById('wc-skip-btn');
    els.closeBtn = document.getElementById('wc-close');

    if (!els.overlay) return;

    // Season clicks
    els.seasons.addEventListener('click', function (e) {
      var btn = e.target.closest('.wc-season-btn');
      if (!btn) return;
      state.selectedSeason = btn.getAttribute('data-season');
      renderSeasons();
      updateButtons();
    });

    els.closeBtn.addEventListener('click', closeModal);
    els.overlay.addEventListener('click', function (e) {
      if (e.target === els.overlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && els.overlay.classList.contains('is-open')) closeModal();
    });

    els.backBtn.addEventListener('click', function () {
      if (state.currentStep > 0) goToStep(state.currentStep - 1);
    });

    els.nextBtn.addEventListener('click', function () {
      hideError();
      var stepName = state.steps[state.currentStep];
      var isLast = state.currentStep === state.steps.length - 1;

      if (stepName === 'custom') {
        if (!state.termsAccepted) {
          showError('Du skal acceptere handelsbetingelserne.');
          return;
        }
        if (!state.customBP) {
          showError('Vælg venligst et krydsmål.');
          return;
        }
        if (state.customET === null) {
          showError('Angiv venligst en gyldig ET-værdi.');
          return;
        }
        goToStep(state.currentStep + 1);
      } else if (isLast) {
        // Season step — add and redirect
        if (!state.selectedSeason) {
          showError('Vælg venligst en dæktype.');
          return;
        }
        addAndGoToTires();
      } else {
        goToStep(state.currentStep + 1);
      }
    });

    els.skipBtn.addEventListener('click', function () {
      // For custom: validate before skipping
      if (state.isCustom && state.steps[state.currentStep] === 'custom') {
        if (!state.termsAccepted || !state.customBP || state.customET === null) {
          showError('Udfyld venligst custom mål først.');
          return;
        }
      }
      addRimOnlyAndGoToCart();
    });

    interceptAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
